<template>
  <v-dialog v-model="visible" persistent max-width="560">
    <v-card>
      <v-card-title>
        {{ isEditing ? "Editar localidade" : "Nova localidade" }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model.trim="form.name"
            :rules="nameRules"
            label="Nome"
            outlined
            required
            autofocus
          />
          <v-textarea
            v-model.trim="form.description"
            label="Descrição"
            outlined
            rows="3"
          />
          <v-switch
            v-if="isEditing && place && place.active === false"
            v-model="form.active"
            label="Reativar localidade"
            color="indigo"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn color="indigo" dark :loading="loading" @click="save">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createPlace, updatePlace } from "../../../services/places";

export default {
  name: "PlaceFormDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    place: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      form: {
        name: "",
        description: "",
        active: true,
      },
      nameRules: [
        (value) => !!value || "Informe o nome da localidade.",
        (value) =>
          !value ||
          value.length >= 2 ||
          "O nome deve possuir pelo menos 2 caracteres.",
      ],
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isEditing() {
      return !!(this.place && this.place.id);
    },
  },
  watch: {
    value(value) {
      if (value) this.fillForm();
    },
  },
  methods: {
    fillForm() {
      this.form = {
        name: this.place ? this.place.name : "",
        description: this.place ? this.place.description || "" : "",
        active: this.place ? this.place.active !== false : true,
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    close() {
      this.visible = false;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        const data = {
          name: this.form.name,
          description: this.form.description,
          active: this.form.active,
        };

        if (this.isEditing) {
          if (this.place.active === false && this.form.active) {
            data.deleted_at = null;
          }
          await updatePlace(this.place.id, data);
        } else {
          await createPlace(data);
        }

        this.$emit("saved", {
          message: this.isEditing
            ? "Localidade atualizada com sucesso."
            : "Localidade criada com sucesso.",
        });
        this.close();
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
